export default __webpack_public_path__ + "static/media/capricorn.aa8d7f1d.png";